import { constants } from "../config/constants"
import { api } from "../plugins/api_settings"

export default {
  methods: {
    $init(token, data) {
      /* AUTH */
      this.$store.commit("auth/SET_CURRENT_USER", {
        user: data,
        token: token
      })

      /* SETTINGS */
      this.$store.dispatch("settings/init", data.settings)
      let locale = this.$getSetting("locale")

      /* FRONT END LOCALE */
      let fe_locale = this.$store.getters["settings/fe_locale"]
      let path = this.$router.currentRoute.path
      if ((path.startsWith("/f/") || path.startsWith("/auth/")) && fe_locale) {
        // If previous route path is login page, use the locale from the user's settings
        if (path.startsWith("/auth/") && path.endsWith("/login")) {
          locale = locale
        } else {
          locale = fe_locale
        }
      }
      this.$i18n.locale = locale

      /* ORGANISATION */
      //if (!this.$cookies.get(`${this.COOKIE_PREFIX}organisation_id`)) {
      axios
        .get(this.API_URL + "organisation/my")
        .then((res) => {
          let data = res.data.data

          this.$store.dispatch("organisations/setOrganisationId", data.id)
          this.$store.dispatch("organisations/setOrganisation", data)

          this.$cookies.set(`${this.COOKIE_PREFIX}tenant_id`, data.tenant_id)
          this.$cookies.set(`${this.COOKIE_PREFIX}organisation`, data)
          this.$cookies.set(`${this.COOKIE_PREFIX}organisation_id`, data.id)
        })
        .catch((err) => console.log(err))
      //}
    },
    $setPageTitle: function (title) {
      this.$store.dispatch("master/setPageTitle", title)
    },
    $setCurrentModule: function (module) {
      this.$store.dispatch("master/setCurrentModule", module)
    },
    $toggleDrawer: function (bool = undefined) {
      let drawer = this.$store.getters["master/drawerOpen"]
      drawer = !drawer

      if (bool !== undefined) {
        drawer = bool
      }

      this.$store.dispatch("master/setDrawerOpen", drawer)
    },
    $globalMessages(message, type, show = true) {
      this.$store.dispatch("master/setAlert", {
        message: message,
        type: type == "" ? "success" : type,
        show: show
      })
    },
    $formatErrorMessages(errors) {
      let messages = ""

      if (typeof errors === "string") {
        messages = errors
      } else {
        _.map(errors, function (data) {
          messages += _.map(data).join("\n\t")
        })
      }

      return messages
    },
    $setAuthorization(token) {
      axios.defaults.headers.common["Authorization"] = `Bearer ${token}`
      api.defaults.headers.common["Authorization"] = `Bearer ${token}`
    },
    $setCertRegAuthorization(token) {
      axios.defaults.headers.common["X-CertRegToken"] = token
    },
    $setTenantInAxiosHeader(tenant_id) {
      axios.defaults.headers.common["X-TenantId"] = tenant_id
    },
    $setClientTenantInAxiosHeader(client_id = null, client_secret = null) {
      axios.defaults.headers.common["Client-Id"] = client_id ? client_id : this.TENANT_CLIENT_ID
      axios.defaults.headers.common["Client-Secret"] = client_secret ? client_secret : this.$reverseString(this.TENANT_CLIENT_SECRET)
    },
    $unsetClientTenantInAxiosHeader() {
      delete axios.defaults.headers.common["Client-Id"]
      delete axios.defaults.headers.common["Client-Secret"]
    },
    $checkAllCookies() {
      let tenant_token = this.$cookies.get(`${this.COOKIE_PREFIX}tenant_token`)
      let certreg_token = this.$cookies.get(`${this.COOKIE_PREFIX}certreg_token`)
      let tenant_id = this.$cookies.get(`${this.COOKIE_PREFIX}tenant_id`)

      if (tenant_token && certreg_token && tenant_id) {
        return true
      }

      return false
    },
    $clearCookies() {
      this.$cookies.remove(`${this.COOKIE_PREFIX}tenant_token`)
      this.$cookies.remove(`${this.COOKIE_PREFIX}certreg_token`)
      this.$cookies.remove(`${this.COOKIE_PREFIX}tenant_id`)
      this.$cookies.remove(`${this.COOKIE_PREFIX}organisation`)
      this.$cookies.remove(`${this.COOKIE_PREFIX}organisation_id`)
    },
    $can: function (action, local = false) {
      let vm = this
      let bool = false
      let user = local ? this.$store.getters["auth/localUser"] : this.$store.getters["auth/user"]

      _.forEach(user.roles, function (role) {
        if (role.slug == "system-developer") bool = true

        if (!bool) {
          _.forEach(role.permissions, function (permission) {
            if (permission == action) bool = true
          })
        }
      })

      return bool
    },
    $hasRole: function (action, strict = false) {
      let bool = false
      let user = this.$store.getters["auth/user"]

      if (!user) {
        user = this.$store.getters["auth/localUser"]
      }

      _.forEach(user.roles, function (role) {
        if (role.slug == action) bool = true

        if (!strict && role.slug == "system-developer") {
          bool = true
        }
      })

      return bool
    },
    $uuid: function () {
      return Math.random().toString(36).substr(2, 9)
    },
    $addLog: function (user_id, action_model, action_id, action, before_value = "", after_value = "") {
      let user = this.$store.getters["auth/localUser"]

      axios
        .post(this.API_URL + "log", {
          user_id: user_id ? user_id : user.id,
          action: action,
          action_model: action_model,
          action_id: action_id,
          before_value: before_value,
          after_value: after_value
        })
        .then((res) => { })
        .catch((err) => console.log(err))
    },
    $getCity(code, country) {
      if (country) {
        country = this.countryAlpha2(country)
      }

      if (!country) {
        country = "NO"
      }

      let bringAxios = axios.create({
        headers: {
          "X-MyBring-API-Uid": this.BRING_API_UID,
          "X-MyBring-API-Key": this.BRING_API_KEY
        }
      })

      return bringAxios.get(this.BRING_API_URL + `postalCode/${country}/getCityAndType/${code}.json`)
    },
    $api1881SearchVAT(search) {
      let api1881Axios = axios.create({
        headers: {
          "Ocp-Apim-Subscription-Key": this.API1881_API_KEY,
        }
      })

      return api1881Axios.get(this.API1881_API_URL + `/lookup/organizationnumber/${search}`)
    },
    $api1881SearchName(search) {
      let api1881Axios = axios.create({
        headers: {
          "Ocp-Apim-Subscription-Key": this.API1881_API_KEY,
        }
      })

      return api1881Axios.get(this.API1881_API_URL + `/search/company?query=${search}&limit=10`)
    },
    $api1881SearchID(id) {
      let api1881Axios = axios.create({
        headers: {
          "Ocp-Apim-Subscription-Key": this.API1881_API_KEY,
        }
      })

      return api1881Axios.get(this.API1881_API_URL + `/lookup/id/${id}`)
    },
    $queryString: function (pagination, search_params) {
      let sort_by = "",
        sort_order = "asc"
      let queryString = Object.keys(search_params)
        .map((key) => (search_params[key] === undefined || search_params[key] == null ? "" : "query_" + key + "=" + search_params[key]))
        .join("&")

      if (pagination.multisort) {
      } else {
        if (pagination.sortBy.length == 1) {
          sort_by = pagination.sortBy[0]
        }

        if (pagination.sortDesc && pagination.sortDesc.length == 1) {
          sort_order = pagination.sortDesc[0] ? "desc" : "asc"
        }
      }

      let query = `page=${pagination.page}&sort_by=${sort_by}&sort_order=${sort_order}&rows_per_page=${pagination.itemsPerPage}&${queryString}`

      return query
    },
    $getLocalStorage(key, type) {
      let item = localStorage.getItem(key)

      if (item) {
        return item
      }

      // defaults
      if (type == 'page') {
        return 1;
      }
    },
    $getSetting: function (key) {
      let user = localStorage.getItem("__crrntUser")

      if (user) {
        user = JSON.parse(user)

        let setting = user.settings.find((i) => i.key == key)
        if (setting && setting.value) {
          if (key == "rows_per_page") {
            return Number(setting.value)
          }

          return setting.value
        }
      }

      if (key == "rows_per_page") {
        return constants.SETTING_DEFAULT_ROWS_PER_PAGE
      }
      if (key == "locale") {
        return constants.SETTING_DEFAULT_LOCALE
      }
    },
    $updateSetting: function (key, value) {
      this.$store.dispatch("settings/update", { key: key, value: value })
    },
    $updateSettingDB: function (key, value) {
      this.$store.dispatch("settings/updatedb", { key: key, value: value })
    },
    $localeChange(locale) {
      let vm = this

      let user = this.$store.getters["auth/user"]
      let data = []

      data.push({ key: "locale", value: locale })

      axios
        .post(this.API_URL + "setting", {
          user_id: user.id,
          data: JSON.stringify(data)
        })
        .then((res) => {
          vm.$i18n.locale = locale
          vm.$updateSetting("locale", locale)
        })
        .catch((err) => console.log(err))
    },
    $classFormatDuration: function (data) {
      let duration = data.duration
      let duration_type = data.duration_type

      return duration + " " + this.$dd_classes_duration_type(duration_type)
    },
    $html: function (id) {
      return document.getElementById(id)
    },
    $getFileExtension(fileName) {
      if (fileName) {
        var index = fileName.lastIndexOf(".")
        if (index >= 0) return fileName.substr(index + 1).toLowerCase()
      }

      return fileName
    },
    $getFileName(fileName) {
      if (fileName) fileName = fileName.replace(/\.[^/.]+$/, "")

      return fileName
    },
    $hasPreview(filename) {
      let valid_ext = ["jpg", "jpeg", "png", "heic", "pdf"]
      let ext = this.$getFileExtension(filename)
      return valid_ext.includes(ext)
    },
    $getDefaultDropdown: function (data) {
      let item = data.find((i) => i.default == 1)

      return item ? item.key : null
    },
    $formatBytes: function (bytes, decimals = 2) {
      if (bytes === 0) return "0 Bytes"

      const k = 1024
      const dm = decimals < 0 ? 0 : decimals
      const sizes = ["Bytes", "KB", "MB", "GB", "TB", "PB", "EB", "ZB", "YB"]

      const i = Math.floor(Math.log(bytes) / Math.log(k))

      return parseFloat((bytes / Math.pow(k, i)).toFixed(dm)) + " " + sizes[i]
    },
    $dateFormatSetter: function (val, format = null) {
      if (format == null) {
        format = this.DATE_FORMAT
      }

      let checker = this.moment(val, format, true)
      let date = val

      if (checker.isValid()) {
        date = this.moment(val, format).format(this.MYSQL_DATE_FORMAT)
      }

      return date
    },
    $dateFormatGetter: function (val) {
      return this.moment(val, this.MYSQL_DATE_FORMAT, true).isValid() ? this.moment.utc(val).format(this.DATE_FORMAT) : val
    },
    $timeFormatSetter: function (val, format = null) {
      if (format == null) {
        format = this.TIME_FORMAT
      }

      let checker = this.moment(val, format, true)
      let time = val

      if (checker.isValid()) {
        time = this.moment(val, format).format(this.TIME_FORMAT)
      }

      return time
    },
    $timeFormatGetter: function (val) {
      return this.moment(val, this.MYSQL_TIME_FORMAT, true).isValid()
        ? this.moment.utc(val, this.TIME_FORMAT).format(this.TIME_FORMAT)
        : val
    },
    $priceFormatGetter: function (val) {
      if (val !== null) {
        if (!isNaN(val)) {
          val = Intl.NumberFormat("nb-NO").format(val)
          val = val.replace(/[\s]/g, "")
          return val
        }
      }

      return null
    },
    $priceFormatSetter: function (val) {
      if (val) {
        val = val.replace(/[\s]/g, "")
        val = val.replace(/[,]/g, ".")

        if (!isNaN(val)) {
          return Intl.NumberFormat("en-US", { useGrouping: false }).format(val)
        }
      }

      return null
    },
    $keyDown_IntOnly: function (event, strictDigitOnly = false) {
      event = event ? event : window.event
      var charCode = event.which ? event.which : event.keyCode
      if (charCode > 31 && (charCode < 48 || charCode > 57)) {
        event.preventDefault()
      } else {
        return true
      }
    },
    $keyDown_PriceOnly: function (event) {
      var regex = /^[0-9,]+$/i

      var char = String.fromCharCode(!event.charCode ? event.which : event.charCode)
      if (!regex.test(char)) {
        event.preventDefault()
      }

      return true
    },
    $locale_bcp47: function (val) {
      let locale = this.$getSetting("locale")

      if (val) locale = val

      if (locale == "no") locale = "nb"

      return locale
    },
    $nl2br(str) {
      if (str) {
        return str.replace(new RegExp("\r?\n", "g"), "<br />")
      }

      return ""
    },
    $diffObj: function (object, base) {
      function changes(object, base) {
        return _.transform(object, function (result, value, key) {
          if (!_.isEqual(value, base[key])) {
            result[key] = _.isObject(value) && _.isObject(base[key]) ? changes(value, base[key]) : value
          }
        })
      }
      return changes(object, base)
    },
    $leaveFormConfirmation: function (next, obj1, obj2, action, formValid = true) {
      if (!_.isEqual(obj1, obj2)) {
        this.$awn.confirm(
          this.$t("global.save_changes"),
          () => {
            action()

            if (formValid) {
              next()
            } else {
              next(false)
            }
          },
          () => {
            next()
          },
          {
            labels: {
              confirmOk: this.$t("global.yes"),
              confirmCancel: this.$t("global.no")
            }
          }
        )
      } else {
        next()
      }
    },

    $getAppVersion: function () {
      return process.env.VUE_APP_VERSION
    },
    $checkAppVersion() {
      let vm = this

      vm.$store.dispatch("master/setAxiosHideLoader", false)

      axios
        .get(vm.API_URL + "version")
        .then((res) => {
          let api_version = res.data.version
          let app_version = process.env.VUE_APP_VERSION
          let isnew = api_version != app_version

          vm.$store.dispatch("master/setNewVersionSnackbar", isnew)
        })
        .catch((err) => console.log(err))
    },
    $reverseString(str) {
      if (str) {
        return str.split("").reverse().join("")
      }

      return ""
    },
    $isValidJSONString(str) {
      try {
        JSON.parse(str)
        return true
      } catch (e) {
        return false
      }
      return true
    },
    $arrayBufferValidation(string) {
      let data = this.$arrayBufferToString(string)

      try {
        if (this.$isValidJSONString(data) && data) {
          var json = JSON.parse(data)

          if (json.status == "error") {
            let errors = this.$formatErrorMessages(json.message || this.$t("auth.error"))
            this.$globalMessages(errors, "error")
            window.scrollTo({ top: 0, behavior: "smooth" })
          }

          return false
        }
      } catch (e) {
        return true
      }

      return true
    },
    $arrayBufferToString(buffer) {
      try {
        return String.fromCharCode.apply(null, new Uint8Array(buffer))
      } catch (e) {
        return null
      }
    },
    $dataURLtoFile: function (dataurl, filename) {
      var arr = dataurl.split(","),
        mime = arr[0].match(/:(.*?);/)[1],
        bstr = atob(arr[1]),
        n = bstr.length,
        u8arr = new Uint8Array(n)

      while (n--) {
        u8arr[n] = bstr.charCodeAt(n)
      }

      return new File([u8arr], filename, { type: mime })
    },
    $calculateAspectRatioFit: function (srcWidth, srcHeight, maxWidth, maxHeight) {
      var ratio = Math.min(maxWidth / srcWidth, maxHeight / srcHeight)

      return { width: srcWidth * ratio, height: srcHeight * ratio }
    },
    $smsCounter(text, overrideTags = []) {
      let text_per_sms = 160
      let sms_length = text ? text.length : 0
      let tenant_url = `https://${window.location.hostname}/f/url/6107a66e40dfe` // {link} length

      // set default tags and counts
      let tags = []
      tags.push({ tag: "{course_name}", count: 45 })
      tags.push({ tag: "{organisation_name}", count: 25 })
      tags.push({ tag: "{link}", count: tenant_url.length }) // e.g https://avalia.kurswebtest.no/f/url/6107a66e40dfe

      // check if we need to override the count of tags
      overrideTags.forEach((item) => {
        let idx = tags.findIndex((i) => i.tag == item.tag)
        if (idx >= 0) {
          tags[idx] = overrideTags.find((i) => i.tag == item.tag)
        }
      })

      // calculate sms length
      tags.forEach((item) => {
        if (text && text.indexOf(item.tag) !== -1) {
          let regex = new RegExp(`${item.tag}`, "g")
          let count = (text.match(regex) || []).length

          sms_length = sms_length - item.tag.length * count // remove the count of the found tag
          sms_length = sms_length + item.count * count // add the new count
        }
      })

      let no_of_sms = Math.ceil(sms_length / text_per_sms) + " SMS"
      return {
        html:
          "<span class='float-left'>" +
          no_of_sms +
          "</span>  <span class='sms-counter'> Approx. " +
          sms_length +
          " / " +
          text_per_sms * 2 +
          "</span>",
        count: sms_length
      }
    },
    $getGenericCourseEmailSMSTags(type, module = "") {
      let tags = {}

      if (type == "email") {
        if (module == "participant") {
          tags = {
            first_name: "",
            last_name: "",
            tenant_organisation_name: "",
          }
        } else {
          tags = {
            first_name: "",
            last_name: "",
            course_name: "",
            course_start_date: "",
            course_start_time: "",
            course_end_date: "",
            course_end_time: "",
            course_dates: "",
            full_address: "",
            tenant_organisation_name: "",
            course_view_shortlink: "Link til forenklet kursside. Trenger ikke innlogging."
          }
        }
      }

      if (type == "sms") {
        tags = {
          course_view_shortlink: "Link til forenklet kursside. Trenger ikke innlogging.",
          organisation_name: "",
          course_name: ""
        }
      }

      return tags
    },
    $getValidUrl(url = "") {
      let newUrl = window.decodeURIComponent(url)
      newUrl = newUrl.trim().replace(/\s/g, "")

      if (/^(:\/\/)/.test(newUrl)) {
        return `http${newUrl}`
      }
      if (!/^(f|ht)tps?:\/\//i.test(newUrl)) {
        return `http://${newUrl}`
      }

      return newUrl
    },
    $slug(val) {
      if (val) {
        return val
          .toLowerCase()
          .replace(/ /g, "-")
          .replace(/[^\w-]+/g, "")
      }

      return null
    },
    $formatPhoneNumber(mobile, code) {
      let data = null

      if (mobile && code) {
        mobile = mobile.replace(/[^0-9]+/g, '')
        data = "+" + code + mobile
      }

      return data
    },
    $inputPhoneNumber(formattedNumber, { number, valid, country }) {
      console.log(formattedNumber)
      console.log(number)
    },
    $getHashChangeLog() {
      let content = require("!raw-loader!@/assets/changelog.md").default
      let hash = this.$md5(content)
      return hash
    },
    $hasNewVersionChangeLog() {
      let currentHash = this.$getHashChangeLog()
      let myHash = this.$getSetting("changelog_hash")

      return !Boolean(currentHash == myHash)
    },
    $md5(value) {
      var MD5 = function (d) { var r = M(V(Y(X(d), 8 * d.length))); return r.toLowerCase() }; function M(d) { for (var _, m = "0123456789ABCDEF", f = "", r = 0; r < d.length; r++)_ = d.charCodeAt(r), f += m.charAt(_ >>> 4 & 15) + m.charAt(15 & _); return f } function X(d) { for (var _ = Array(d.length >> 2), m = 0; m < _.length; m++)_[m] = 0; for (m = 0; m < 8 * d.length; m += 8)_[m >> 5] |= (255 & d.charCodeAt(m / 8)) << m % 32; return _ } function V(d) { for (var _ = "", m = 0; m < 32 * d.length; m += 8)_ += String.fromCharCode(d[m >> 5] >>> m % 32 & 255); return _ } function Y(d, _) { d[_ >> 5] |= 128 << _ % 32, d[14 + (_ + 64 >>> 9 << 4)] = _; for (var m = 1732584193, f = -271733879, r = -1732584194, i = 271733878, n = 0; n < d.length; n += 16) { var h = m, t = f, g = r, e = i; f = md5_ii(f = md5_ii(f = md5_ii(f = md5_ii(f = md5_hh(f = md5_hh(f = md5_hh(f = md5_hh(f = md5_gg(f = md5_gg(f = md5_gg(f = md5_gg(f = md5_ff(f = md5_ff(f = md5_ff(f = md5_ff(f, r = md5_ff(r, i = md5_ff(i, m = md5_ff(m, f, r, i, d[n + 0], 7, -680876936), f, r, d[n + 1], 12, -389564586), m, f, d[n + 2], 17, 606105819), i, m, d[n + 3], 22, -1044525330), r = md5_ff(r, i = md5_ff(i, m = md5_ff(m, f, r, i, d[n + 4], 7, -176418897), f, r, d[n + 5], 12, 1200080426), m, f, d[n + 6], 17, -1473231341), i, m, d[n + 7], 22, -45705983), r = md5_ff(r, i = md5_ff(i, m = md5_ff(m, f, r, i, d[n + 8], 7, 1770035416), f, r, d[n + 9], 12, -1958414417), m, f, d[n + 10], 17, -42063), i, m, d[n + 11], 22, -1990404162), r = md5_ff(r, i = md5_ff(i, m = md5_ff(m, f, r, i, d[n + 12], 7, 1804603682), f, r, d[n + 13], 12, -40341101), m, f, d[n + 14], 17, -1502002290), i, m, d[n + 15], 22, 1236535329), r = md5_gg(r, i = md5_gg(i, m = md5_gg(m, f, r, i, d[n + 1], 5, -165796510), f, r, d[n + 6], 9, -1069501632), m, f, d[n + 11], 14, 643717713), i, m, d[n + 0], 20, -373897302), r = md5_gg(r, i = md5_gg(i, m = md5_gg(m, f, r, i, d[n + 5], 5, -701558691), f, r, d[n + 10], 9, 38016083), m, f, d[n + 15], 14, -660478335), i, m, d[n + 4], 20, -405537848), r = md5_gg(r, i = md5_gg(i, m = md5_gg(m, f, r, i, d[n + 9], 5, 568446438), f, r, d[n + 14], 9, -1019803690), m, f, d[n + 3], 14, -187363961), i, m, d[n + 8], 20, 1163531501), r = md5_gg(r, i = md5_gg(i, m = md5_gg(m, f, r, i, d[n + 13], 5, -1444681467), f, r, d[n + 2], 9, -51403784), m, f, d[n + 7], 14, 1735328473), i, m, d[n + 12], 20, -1926607734), r = md5_hh(r, i = md5_hh(i, m = md5_hh(m, f, r, i, d[n + 5], 4, -378558), f, r, d[n + 8], 11, -2022574463), m, f, d[n + 11], 16, 1839030562), i, m, d[n + 14], 23, -35309556), r = md5_hh(r, i = md5_hh(i, m = md5_hh(m, f, r, i, d[n + 1], 4, -1530992060), f, r, d[n + 4], 11, 1272893353), m, f, d[n + 7], 16, -155497632), i, m, d[n + 10], 23, -1094730640), r = md5_hh(r, i = md5_hh(i, m = md5_hh(m, f, r, i, d[n + 13], 4, 681279174), f, r, d[n + 0], 11, -358537222), m, f, d[n + 3], 16, -722521979), i, m, d[n + 6], 23, 76029189), r = md5_hh(r, i = md5_hh(i, m = md5_hh(m, f, r, i, d[n + 9], 4, -640364487), f, r, d[n + 12], 11, -421815835), m, f, d[n + 15], 16, 530742520), i, m, d[n + 2], 23, -995338651), r = md5_ii(r, i = md5_ii(i, m = md5_ii(m, f, r, i, d[n + 0], 6, -198630844), f, r, d[n + 7], 10, 1126891415), m, f, d[n + 14], 15, -1416354905), i, m, d[n + 5], 21, -57434055), r = md5_ii(r, i = md5_ii(i, m = md5_ii(m, f, r, i, d[n + 12], 6, 1700485571), f, r, d[n + 3], 10, -1894986606), m, f, d[n + 10], 15, -1051523), i, m, d[n + 1], 21, -2054922799), r = md5_ii(r, i = md5_ii(i, m = md5_ii(m, f, r, i, d[n + 8], 6, 1873313359), f, r, d[n + 15], 10, -30611744), m, f, d[n + 6], 15, -1560198380), i, m, d[n + 13], 21, 1309151649), r = md5_ii(r, i = md5_ii(i, m = md5_ii(m, f, r, i, d[n + 4], 6, -145523070), f, r, d[n + 11], 10, -1120210379), m, f, d[n + 2], 15, 718787259), i, m, d[n + 9], 21, -343485551), m = safe_add(m, h), f = safe_add(f, t), r = safe_add(r, g), i = safe_add(i, e) } return Array(m, f, r, i) } function md5_cmn(d, _, m, f, r, i) { return safe_add(bit_rol(safe_add(safe_add(_, d), safe_add(f, i)), r), m) } function md5_ff(d, _, m, f, r, i, n) { return md5_cmn(_ & m | ~_ & f, d, _, r, i, n) } function md5_gg(d, _, m, f, r, i, n) { return md5_cmn(_ & f | m & ~f, d, _, r, i, n) } function md5_hh(d, _, m, f, r, i, n) { return md5_cmn(_ ^ m ^ f, d, _, r, i, n) } function md5_ii(d, _, m, f, r, i, n) { return md5_cmn(m ^ (_ | ~f), d, _, r, i, n) } function safe_add(d, _) { var m = (65535 & d) + (65535 & _); return (d >> 16) + (_ >> 16) + (m >> 16) << 16 | 65535 & m } function bit_rol(d, _) { return d << _ | d >>> 32 - _ }
      var result = MD5(value)
      return result
    },
    $validateEmail(value) {
      return value.match(
        /^(([^<>()[\]\\.,;:\s@\"]+(\.[^<>()[\]\\.,;:\s@\"]+)*)|(\".+\"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/
      );
    },
    $handleServerSideError(error) {
      let locale = this.$i18n.locale

      switch (error.response && error.response.status) {
        case 404:
          this.$awn.alert(error.response.data.message)

          // if (this.$isLoggedIn() === true) this.$router.push(`${this.APP_URL}dashboard`)
          // else this.$router.push(`${this.AUTH_URL}${locale}/login`)
          break
        case 422:
          let message = this.$t("global.something_went_wrong")
          if (error.response.data.errors) {
            message = Object.values(error.response.data.errors)[0][0]
          } else {
            if (error.response.data.message) {
              message = error.response.data.message
            }
          }

          this.$awn.alert(message)
          break
        case 401:
          this.$awn.alert(this.$t("auth.authFail"))
          this.$router.push(`${this.AUTH_URL}${locale}/login`)
          break
        case 499:
          this.$awn.alert(error.response.data.message)
          this.$logout()
          break
        default:
          this.$awn.alert(this.$t("global.something_went_wrong"))
          break
      }
    },
    $routeExtraModule(module) {
      let paidModules = {
        equipment: ["equipment-manufacturers", "equipment-categories", "equipment-models", "equipment-types", "equipments"],
        checklist: ["checklist-properties", "checklist-forms"]
      }

      let status = null

      Object.keys(paidModules).forEach((key) => {
        if (paidModules[key].includes(module)) {
          status = this.$hasExtraModule(key)
        }
      })

      return status
    },
    $hasExtraModule(slug) {
      let org = this.$cookies.get(`${this.COOKIE_PREFIX}organisation`)
      if (org) {
        let module = org.modules.find(i => i.slug == slug)
        if(module && module.status) {
          return 'active'
        }

        if(module && !module.status && module.activated_tracker) {
          return 'view'
        }
        
        return 'inactive'
      }

      return null
    },
    $getMatchGrade(...args) {
      let match = 0
      let grade = 0

      for (let index = 0; index < args.length; index++) {
        let data = args[index]
        if (data.length == 2 && data[0] == data[1]) {
          match++
        }
      }

      grade = (match / args.length) * 100
      return grade
    },
    $formatAPICompanyName(str) {
      let abbrWords = /^(AS|ASA|A\/S|DA|AB|SRL|SA)$/i;
      let words = str.split(' ');  

      words = words.map(function(word, index) {
        if (index > 0 && ~word.search(abbrWords)) {
          return word;                 // If it's a small word, don't change it.
        }
        
        if (~word.lastIndexOf('.', 1)) { // If it contains periods, it's an abbreviation: Uppercase.
          return word.toUpperCase();   // lastIndexOf to ignore the last character.
        }

        // Capitalize the fist letter if it's not a small word or abbreviation.
        return word.charAt(0).toUpperCase() + word.substr(1).toLowerCase(); 
      });
      
      return words.join(' ');
    }
  }
}
